module.exports = {
    API_DOMAIN: 'https://api.discguard.timcreated.me/',
    // API_DOMAIN: 'http://localhost:4000/',
};